module.exports = __webpack_public_path__ + "static/img/097_TO8_1774_og.f440c60.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/097_TO8_1774_og.jpg
// module id = Acp7
// module chunks = 0